




var num = 0;
jQuery(function(){
   jQuery('.fullScreenMenu-content__list-item-link span').mouseenter(function(){
      num++;
      //マウスを乗せたら色が変わる
      let myid = $(this).attr('id');
      //console.log(myid);

      $(".fullScreenMenu-content__area-list-item").removeClass('fadeIn');
      $(".fullScreenMenu-content__area-list-item").addClass('fadeOut');

        if(myid == "head_business") {
            $("#area_business").removeClass('fadeOut');
            $("#area_business").addClass('fadeIn');
        } else if(myid == "head_works"){
          $("#area_works").removeClass('fadeOut');
          $("#area_works").addClass('fadeIn');
        } else if(myid == "head_recruit"){
          $("#area_recruit").removeClass('fadeOut');
          $("#area_recruit").addClass('fadeIn');
        }
   });
})